import apiHandler from "middlewares/apiHandler";
import {
  OrgGHGTargetModel,
  OrgGHGTargetGridModel,
} from "pages/Client/Organization/data/OrgGHGTargetModel";

export const _getOrgGHGTargetsByOrgId = async (orgId: number) => {
  return apiHandler.get<Array<OrgGHGTargetModel>>(
    `OrganizationGHGTargets/organization/${orgId}`
  );
};

export const _getCustomOrgGHGTargetsByOrgId = async (orgId: number) => {
  return apiHandler.get<Array<OrgGHGTargetGridModel>>(
    `CustomOrganizationGHGTargets/organization/${orgId}`
  );
};

export const _getOrgGHGTargetByTargetNumber = async (targetNumber: number) => {
  return apiHandler.get<OrgGHGTargetModel>(
    `OrganizationGHGTargets/${targetNumber}`
  );
};

export const _addOrgGHGTarget = async (model: OrgGHGTargetModel) => {
  return apiHandler.post<OrgGHGTargetModel>("OrganizationGHGTarget", model);
};

export const _updateOrgGHGTarget = async (model: OrgGHGTargetModel) => {
  return apiHandler.put<OrgGHGTargetModel>("OrganizationGHGTarget", model);
};

export const _deleteOrgGHGTarget = async (targetNumber: number) => {
  return apiHandler.delete("OrganizationGHGTarget/" + targetNumber);
};
